<template>
    <div ref="editor"></div>
</template>

<script>
import Editor from "wangeditor";
import { BaseConfig } from "@/config.default";
export default {
    props: {
        value: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            size: 1024 * 1024 * 3,
            editor: {},
            flag: 0
        };
    },
    watch: {
        value() {
            if (this.flag === 0) {
                this.editor.txt.html(this.value);
                this.flag = 1;
            }
        }
    },
    mounted() {
        this.editor = new Editor(this.$refs.editor);
        this.editor.customConfig.uploadImgServer =
            process.env.NODE_ENV === "development"
                ? BaseConfig.devImgUrl
                : BaseConfig.proImgUrl;
        this.editor.customConfig.uploadFileName = "file";
        this.editor.customConfig.menus = [
            "head", // 标题
            "bold", // 粗体
            "fontSize", // 字号
            "fontName", // 字体
            "italic", // 斜体
            "underline", // 下划线
            "strikeThrough", // 删除线
            "foreColor", // 文字颜色
            "backColor", // 背景颜色
            "link", // 插入链接
            "list", // 列表
            "justify", // 对齐方式
            "quote", // 引用
            "image", // 插入图片
            "table", // 表格
            "video", // 插入视频
            "undo", // 撤销
            "redo" // 重复
        ];
        this.editor.customConfig.customAlert = info => {
            this.$message.error(info);
        };
        this.editor.customConfig.uploadImgHooks = {
            before: (xhr, editor, files) => {
                const file = files[0];
                const isLtnM = file.size > this.size;
                const isJpg = file.type === "image/jpeg";
                const isPng = file.type === "image/png";
                if (isLtnM) {
                    return {
                        prevent: true,
                        msg: `图片大小超过限制为${this.size}M`
                    };
                } else if (!isJpg && !isPng) {
                    return {
                        prevent: true,
                        msg: "图片格式不正确"
                    };
                }
            },
            success: (xhr, editor, result) => {
                // 图片上传并返回结果，图片插入成功之后触发
                // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
            },
            fail: (xhr, editor, result) => {
                // 图片上传并返回结果，但图片插入错误时触发
                // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
            },
            error: (xhr, editor) => {
                this.$message.error("上传信息出错！！");
            },
            timeout: (xhr, editor) => {
                // 图片上传超时时触发
                // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
            },

            // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
            // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
            customInsert: (insertImg, result, editor) => {
                // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
                // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
                // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
                // console.log(result.image.display_url)
                const url = result.data;
                insertImg(url);
            }
        };
        this.editor.customConfig.onchange = html => {
            this.$emit("input", html);
        };
        this.editor.create();
        console.log("test", this.value);
        this.editor.txt.html(this.value);
    }
};
</script>

<style lang='scss'>
// .w-e-text {
//     overflow: auto!important;
// }
// .w-e-toolbar .w-e-menu{
//     z-index: 222!important;
// }
// .w-e-text-container {
//     z-index: 222!important;
// }
</style>
